import * as React from 'react';
import styled from 'styled-components';

import { useGlobalState } from './contexts/state/GlobalStateContext';
import { Nav } from './Nav';
import { MapView } from './map/MapView';
import { InfoDialog } from './dialogs/Info/InfoDialog';
import { LayerPane } from './panes/LayerPane';
import { StructurePane } from './panes/StructurePane';
import { ReferencePane } from './panes/ReferencePane';
import { ProjectPane } from './panes/ProjectPane';
import { AreaPane } from './panes/AreaPane';
import { useAuth } from './contexts/auth/useAuth';
import { SystemsManager } from './panes/SystemPane';
import { UsersManager } from './panes/UserPane';
import { AccountManager } from './panes/AccountPane/AccountManager';
import { PaneController } from './ui/Pane/PaneController';
import { SpeciesManager } from './panes/SpeciesPane/SpeciesManager';

interface IProps {
  /** @ignore */
  className?: string;
}

const RootBase = (props: IProps) => {
  const auth = useAuth();

  // ProtectedRoute already gates on isAuthenticated, but the /me round-trip
  // can still be in flight at this point. Render nothing until we have the
  // user record.
  if(!auth.user) {
    return null;
  }

  return (
    <div className={props.className}>
      <Nav/>
      
      <PaneController modeMap={{
        layers: () => <LayerPane/>,
        project: () => <ProjectPane/>,
        structures: () => <StructurePane/>,
        references: () => <ReferencePane/>,
        areas: () => <AreaPane/>,
        systems: () => <SystemsManager/>,
        users: () => <UsersManager/>,
        species: () => <SpeciesManager/>,
        info: () => <InfoDialog/>,
        account: () => <AccountManager/>
      }}/>
            
      <MapView/>      
    </div>
  )
}

const RootStyled = styled(RootBase)`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`

const Root = (props: IProps) => <RootStyled {...props}/>

export { Root }
